import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import { poster6, poster7, poster8, poster9, poster10} from "../../assets/img";

const Slider2 = () => {
  const images = [poster6, poster7, poster8, poster9, poster10];

  return (
    <div className="ticket-grid-container1">
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          height: "80vh",
          maxHeight: "800px",
        }}
      >
        <Swiper
          className="poster-slider"
          modules={[Autoplay]}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={false}  // remove arrows
          pagination={false}  // remove pagination
          style={{ height: "100%" }}
        >
          {images.map((src, i) => (
            <SwiperSlide key={i}>
              <img
                src={src}
                alt={`slide-${i}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Slider2;
